export default "/_next/static/media/video.38463198.mp4";